import { combineReducers } from 'redux';

import fetchList from './actions/fetchList';
import createItem from './actions/createItem';
import updateItem from './actions/updateItem';
import deleteItem from './actions/deleteItem';
import fetchGradingSystems from './actions/fetchGradingSystems';
import list from './reducers/list';
import state from './reducers/state';
import gradingSystems from './reducers/gradingSystems';

export const GradebookSystemsActions = {
  fetchList,
  createItem,
  updateItem,
  deleteItem,
  fetchGradingSystems,
};

export default combineReducers({
  list,
  state,
  gradingSystems,
});
